// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3jHFg","content":"LoadingAlert_content__bth1y"};